import { Box } from '@mui/material';
import {
  CustomAutoComplete,
  CustomTextField,
  CustomTextArea,
  HorizontalForm,
  VerticalForm,
  DialogTitle,
} from '../../../common/components';

const AdditionalDataSection = ({
  accountingAccountOptions = [],
  selectedSubcontractor,
  onInputChange,
  onSelectChange,
  isMobile,
}) => {
  return (
    <Box>
      <DialogTitle showSeparator={false} sx={{ p: 0 }}>
        Datos adicionales
      </DialogTitle>
      {isMobile ? (
        <VerticalForm>
          <CustomTextField
            label="Cuota social"
            name="membership_fee"
            type="number"
            value={selectedSubcontractor.membership_fee || '0'}
            onChange={onInputChange}
            size="medium"
            inputProps={{ min: 0, step: 0.01 }}
          />
          <CustomAutoComplete
            label="Cuenta contable"
            name="uuid_default_accounting_account"
            value={selectedSubcontractor.uuid_default_accounting_account || ''}
            onChange={onSelectChange}
            options={accountingAccountOptions}
            size="medium"
          />
          <CustomTextArea
            label="Observaciones"
            name="observations"
            value={selectedSubcontractor.observations || ''}
            onChange={onInputChange}
            rows={3}
          />
        </VerticalForm>
      ) : (
        <HorizontalForm withBorder={false} sx={{ p: 1 }}>
          <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 2, mr: 4 }}>
            <CustomTextField
              label="Cuota social"
              name="membership_fee"
              type="number"
              value={selectedSubcontractor.membership_fee || '0'}
              onChange={onInputChange}
              size="medium"
              inputProps={{ min: 0, step: 0.01 }}
            />
            <CustomAutoComplete
              label="Cuenta contable"
              name="uuid_default_accounting_account"
              value={selectedSubcontractor.uuid_default_accounting_account || ''}
              onChange={onSelectChange}
              options={accountingAccountOptions}
              size="medium"
            />
          </Box>
          <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 2 }}>
            <CustomTextArea
              label="Observaciones"
              name="observations"
              value={selectedSubcontractor.observations || ''}
              onChange={onInputChange}
              rows={3}
            />
          </Box>
        </HorizontalForm>
      )}
    </Box>
  );
};

export default AdditionalDataSection;
